import React from 'react'

import { DefaultCardContainer } from '../style/LoginScreenStyle'

import GenericInput from '../../../GenericComponents/GenericInput'
import GenericCheckbox from '../../../GenericComponents/GenericCheckbox'
import GenericButton from '../../../GenericComponents/GenericButton'

const LoginCardDefaultMode = ({
  userAcceptedPolicies,
  handleAcceptRegisterPolicies,
  handleAcceptNewsletter,
  userAcceptedNewsletter,
  handleGatherRegisterInputData,
  handleRegisterUser,
}) => {
  return (
    <DefaultCardContainer>
      <GenericInput
        type="email"
        onChange={(e) => handleGatherRegisterInputData(e.target.value, 'email')}
        placeholder={'Email'}
      ></GenericInput>
      <GenericInput
        type="password"
        onChange={(e) =>
          handleGatherRegisterInputData(e.target.value, 'password')
        }
        placeholder={'Hasło'}
      ></GenericInput>
      <GenericInput
        type="password"
        onChange={(e) =>
          handleGatherRegisterInputData(e.target.value, 'rePassword')
        }
        placeholder={'Powtórz hasło'}
      ></GenericInput>
      <GenericCheckbox
        regulations={false}
        checkCheckbox={handleAcceptRegisterPolicies}
        isCheckboxChecked={userAcceptedPolicies}
        // Akceptuje regulamin oraz politykę prywatności
        text={
          <div>
            Akceptuje
            <a href="https://fitmatkawariatka.pl/regulamin-aplikacji-od-03-01-2022-r/">
              regulamin
            </a>{' '}
            oraz{' '}
            <a href="https://fitmatkawariatka.pl/polityka-prywatnosci-aplikacja-miazga/">
              politykę prywatności
            </a>
          </div>
        }
        checkboxStyle={{ justify: 'flex-start' }}
        containerStyle={{ justify: 'flex-start', margin: '5% 0 0 0' }}
      />
      <GenericCheckbox
        regulations={false}
        checkCheckbox={handleAcceptNewsletter}
        isCheckboxChecked={userAcceptedNewsletter}
        text={'Chcę dostawać informacje o promocjach i dołączyć do newslettera'}
        checkboxStyle={{ justify: 'flex-start' }}
        containerStyle={{ justify: 'flex-start', margin: '2% 0 0 0' }}
      />
      <GenericButton
        justify={'center'}
        width={'95%'}
        margin={'10% 0 0 2.5%'}
        className="standard"
        onClick={() => handleRegisterUser()}
      >
        Zarejestruj się
      </GenericButton>
    </DefaultCardContainer>
  )
}

export default LoginCardDefaultMode
